import { observer } from 'mobx-react-lite';
import {
  Card,
  CardContent,
  Typography,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Stack,
} from '@mui/material';
import { useManagerTeam } from './ManagerTeamPage';
import type { FHTeamInvite } from '../../api/team_admin_api';

function statusChips(invite: FHTeamInvite) {
  const s = invite.status;
  const chips: { label: string; color?: 'success' | 'warning' | 'error' | 'default' }[] = [];
  if (s.revoked) chips.push({ label: 'Revoked', color: 'error' });
  if (s.cancelled) chips.push({ label: 'Cancelled', color: 'warning' });
  if (s.activated) chips.push({ label: 'Activated', color: 'success' });
  else if (s.email_sent) chips.push({ label: 'Invited', color: 'default' });
  if (!s.paid) chips.push({ label: 'Awaiting billing', color: 'warning' });
  if (chips.length === 0) chips.push({ label: 'Pending', color: 'default' });
  return chips;
}

export const ManagerTeamInvites = observer(() => {
  const { detail } = useManagerTeam();
  if (!detail) return null;

  const { invites } = detail;

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Invites ({invites.length})
        </Typography>
        {invites.length === 0 ? (
          <Alert severity="info">No invites for this team.</Alert>
        ) : (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Email</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Plan</TableCell>
                  <TableCell>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {invites.map((invite) => (
                  <TableRow key={invite.key}>
                    <TableCell>{invite.invite_email || '—'}</TableCell>
                    <TableCell>{invite.user_name || '—'}</TableCell>
                    <TableCell>
                      {invite.current_plan || '—'}
                      {invite.new_plan ? ` → ${invite.new_plan}` : ''}
                    </TableCell>
                    <TableCell>
                      <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap>
                        {statusChips(invite).map((c, i) => (
                          <Chip key={i} label={c.label} size="small" color={c.color} />
                        ))}
                        {invite.billing_error && (
                          <Chip label={invite.billing_error} size="small" color="error" variant="outlined" />
                        )}
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </CardContent>
    </Card>
  );
});
